import { render } from "./ImportanceForm.vue?vue&type=template&id=53aa6c54&lang=pug"
import script from "./ImportanceForm.vue?vue&type=script&lang=js"
export * from "./ImportanceForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__